import React from 'react';
import PropTypes from 'prop-types';
import ConnectedWorklistHelp from './ConnectedWorklistHelp';

function WorklistHelpRouting({ match }) {
  return <ConnectedWorklistHelp />;
}

WorklistHelpRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default WorklistHelpRouting;
